import { axiosInstance2 } from "../../utils/axiosConfig";
import { apiStart, apiComplete, apiFail } from "./common";
import _ from 'lodash';
import * as actionTypes from "./actionTypes";
import { message } from "antd";

export const resendEnvelopToNotSignedSuccess = data => {
    return {
        type: actionTypes.RESEND_ENVELOP_TO_NOT_SIGNED_SUCCESS,
        data: data
    }
}

export const resendEnvelopToNotSignedFailed = data => {
    return {
        type: actionTypes.RESEND_ENVELOP_TO_NOT_SIGNED_FAILED,
        data: data
    }
}

export const resendStateClear = () => {
    return {
        type: actionTypes.CLEAR_RESEND_STATE
    }
}

export const resendEnvelopToNotSigned = (params) => {
    return async dispatch => {
        try {
            const response = await axiosInstance2.post('/api/compliance/resendSignatureEnvelop', params)
            .then(response => {
                if (response["data"]["error"]) {
                    console.error("ERROR :", response["data"]["message"]);
                    // let errorMessage = (response["data"]["display"] != undefined && response["data"]["display"]) ? response["data"]["errorMessage"] : 'Error occured';
                    // message.error(errorMessage)
                    dispatch(resendEnvelopToNotSignedFailed(response["data"]["message"]));
                } else {
                    console.log('successfully resend email',response["data"]["message"]);
                    dispatch(resendEnvelopToNotSignedSuccess(response["data"]["message"]));

                }
            }).catch(error => {
                console.error("ERROR :", error);
                message.error("Cannot reach server");
                dispatch(apiFail("Cannot reach server"));
            })
        } catch (err) {
            console.log('err', err);
            if (err.response) {
                const errors = err.response.data.errors;
                if (errors) {
                    errors.forEach(error => message.error(error.msg));
                }
                dispatch(apiFail(err.response.data));
            } else {
                message.error(err.message)
                dispatch(apiFail(err.message));
            }
        }

    }
}